import React, { useEffect, useState } from "react";
import CommonHeaderComp from "../utils/CommonHeaderComp";
import "../styles/ContactPageStyles/contactStyle.css";
import OrderBtn from "../utils/OrderBtn";
import insta from "../assets/Footer/instaIng.webp";
import fbImg from "../assets/Footer/fbImg.png";
import tiktokImg from "../assets/Footer/tiktokImg.png";
import ytImg from "../assets/Footer/ytImg.png";
import Footer from "../components/Footer";
import swal from "sweetalert";

import sotryImg1 from "../assets/BannerImg/banner2.png";
import sotryImg2 from "../assets/BannerImg/banner3.png";
import img1Toppings from "../assets/StoryPage/img1Toppings.png";
import img2Toppings from "../assets/StoryPage/Img2Toppings.png";
import Aos from "aos";
import "aos/dist/aos.css";
import Map from "../components/Map/Map";

// Locations Images
import Ajax from "../assets/Locations/Ajax.jpg";
import Brampton from "../assets/Locations/Brampton.jpg";
import Collingwood from "../assets/Locations/Collingwood.jpg";
import Edmonton from "../assets/Locations/Edmonton.jpg";
import Guelph from "../assets/Locations/Guelph.jpg";
import Kitchener from "../assets/Locations/Kitchener.jpg";
import Lebovic from "../assets/Locations/Lebovic.jpg";
import Meadows from "../assets/Locations/Meadows.jpg";
import Peterborough from "../assets/Locations/Peterborough.jpg";
// import Regina from "../assets/Locations/Regina.jpg"
import Scarborough from "../assets/Locations/Scarborough.jpg";
import Vaughan from "../assets/Locations/Vaughan.jpg";
import Windsor from "../assets/Locations/Windsor.jpg";
import config from "../config";
import axios from "axios";
import Loader from "../utils/Loader";
import { MdBorderColor } from "react-icons/md";
import { Helmet } from "react-helmet";

const ContactPage = ({ allLocationsData }) => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  // console.log("allLocationsData", allLocationsData)

  const [isLoading, setIsLoading] = useState(false);
  const [contactData, setContactData] = useState(false);
  const [banner1, setBanner1] = useState("");
  const [banner2, setBanner2] = useState("");

  useEffect(() => {
    fetchContactData();
  }, []);
  const fetchContactData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));

    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/contact_details`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setIsLoading(false);
        setContactData(res.data.data[0]);
        // console.log("locations Page data", res.data.data[0]);
        setBanner1(res.data.data[0]?.image1);
        setBanner2(res.data.data[0]?.image2);
      });
    } catch (error) {
      setIsLoading(false);
      console.log("contacpage", error);
    }
  };

  const locations = [
    {
      id: 1,
      name: "Ajax",
      position: [43.850857, -79.02037],
      address: "11 Harwood Ave S UNIT 104, Ajax, ON L1S 2B9",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 0.5:00 PM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Ajax,
    },
    {
      id: 2,
      name: "Lebovic, Scarborough",
      position: [43.777702, -79.233238],
      address: "41 Lebovic Ave, Scarborough, ON M1L 4W1",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Lebovic,
    },
    {
      id: 3,
      name: "Collingwood",
      position: [44.5008, -80.2169],
      address: "350 First St Unit 1, Collingwood, ON L9Y 1B4",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Collingwood,
    },
    {
      id: 4,
      name: "Edmonton",
      position: [53.5461, -113.4937],
      address: "6864 Ellerslie Road SW, Edmonton, AB T6X 1A3",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Edmonton,
    },
    {
      id: 5,
      name: "Guelph",
      position: [43.5448, -80.2482],
      address: "Unit E 119 Silvercreek Parkway North Guelph, ON N1H 3T2",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Guelph,
    },
    {
      id: 6,
      name: "Vaughan",
      position: [43.8262, -79.5562],
      address: "Unit 1, 3883 Highway 7, Vaughan, Ontario, L4L 6C1",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Vaughan,
    },
    {
      id: 7,
      name: "Windsor",
      position: [42.3149, -83.0364],
      address: "1177 Lauzon Road, Windsor, ON N8S 3M9",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Windsor,
    },
    {
      id: 8,
      name: "Kitchener",
      position: [43.4516, -80.4925],
      address: "Unit 15, 509 Wilson Ave, Kitchener, ON N2C 2M4",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Kitchener,
    },
    {
      id: 9,
      name: "Brampton",
      position: [43.7315, -79.7624],
      address: "2760 N Park Dr Unit 66, Brampton, ON L6S 0C5",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Brampton,
    },
    {
      id: 10,
      name: "Peterborough",
      position: [44.3047, -78.32],
      address: "1135 Lansdown St Peterborough, ON K9J 7M2",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Peterborough,
    },
    {
      id: 11,
      name: "Meadows",
      position: [48.9949, -113.4239],
      address: "2384 23 Ave NW, Edmonton, AB T6T 0R1",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Meadows,
    },
    {
      id: 12,
      name: "Scarborough",
      position: [43.7764, -79.2318],
      address: "5631 Steeles Ave East, Unit 6, Scarborough ON M1V 5P6",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 5:00 AM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Scarborough,
    },
  ];

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const [error, setError] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  // form validations
  const validateForm = () => {
    const newErrors = {};

    if (!name) {
      newErrors.name = "Name is required.";
    }

    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!phone) {
      newErrors.phone = "Phone number is required.";
    } else if (phone.length > 10 || phone.length < 10) {
      newErrors.phone = "Phone number must be atleast of 10 digits.";
    } else if (!/^\d{10}$/.test(phone)) {
      newErrors.phone =
        "Phone number must be exactly 10 digits and contain numbers only.";
    }

    if (!subject) {
      newErrors.subject = "Subject is required.";
    }

    if (!message) {
      newErrors.message = "Message is required.";
    }

    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // send Contact Data
  const handleContact = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("name", name);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("subject", subject);
      formData.append("message", message);
      try {
        const response = await axios({
          method: "post",
          url: `${config.apiUrl}/contact-us/store`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }).then((res) => {
          setIsLoading(false);
          swal({
            icon: "success",
            text: "Message Sent Successfully !",
          }).then((data) => {
            setIsLoading(false);
            setName("");
            setPhone("");
            setEmail("");
            setSubject("");
            setMessage("");
          });
        });
      } catch (error) {
        setIsLoading(false);
        swal({
          icon: "error",
          text: "Something went wrong.",
        });
        console.log("Contact Form Error:-", error);
      }
    }
  };

  const getImageSource = (image) => {
    if (typeof image === "string") {
      // If image is a string (URL), return it as is
      return image;
    } else if (image && image instanceof Blob) {
      // If image is an object (file), create an object URL
      return URL.createObjectURL(image);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us- Ice Cream and Desserts Shop in Canada</title>
        <meta
          name="description"
          content="Rollz Ice Cream is located at Ajax, Mississauga, Scarborough, Collingwood, Regina, Edmonton, Guelph, Vaughan, Windsor, Kitchener, Brampton, Brantford, Peterborough, and Halifax."
        />
        <meta
          property="og:title"
          content="Contact Us- Ice Cream and Desserts Shop in Canada"
        />
        <meta
          property="og:description"
          content="Rollz Ice Cream is located at Ajax, Mississauga, Scarborough, Collingwood, Regina, Edmonton, Guelph, Vaughan, Windsor, Kitchener, Brampton, Brantford, Peterborough, and Halifax."
        />
      </Helmet>
      {isLoading && <Loader />}
      <div>
        <CommonHeaderComp
          Heading="Contact US"
          height="60vh"
          pageName="Contact US"
        />

        {/* Image 1  */}
        <div className="position-absolute storyImg1" data-aos="fade-left">
          <img
            src={banner1 ? getImageSource(banner1) : sotryImg1}
            className="img-fluid img1"
            // alt="our story img 1"
            loading="lazy"
          ></img>
          {/* <img
            src={img1Toppings}
            className="img-fluid img1Toping"
            alt="img1 Toppings"
            loading="lazy"
          ></img> */}
        </div>

        {/* Image 2  */}
        <div className="position-absolute storyImg2" data-aos="fade-rigth">
          <img
            src={banner2 ? getImageSource(banner2) : sotryImg2}
            className="img-fluid img2"
            // alt="our story img 2"
            loading="lazy"
          ></img>
          {/* <img
            src={img2Toppings}
            className="img-fluid img2Toping"
            alt="img2 Toppings"
            loading="lazy"
          ></img> */}
        </div>

        <div className="contact_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="contact_details">
                  {/* <h3 className="contactUs mb-4">Contact Us</h3> */}
                  <h3 className="getInTouch mb-5">Get In Touch </h3>
                  <p></p>
                  <div className="col-12 column-gap-2 d-flex flex-wrap row-gap-5 contact_field_container mb-4">
                    <div className="col-12 col-lg-5 col-md-6 contact_field">
                      <div className="contact_icon">
                        <i className="bi bi-telephone-inbound"></i>
                      </div>
                      <div className="d-flex flex-column align-items-start justify-content-start contact_info">
                        <h4>Phone</h4>
                        <a
                          href={`tel:${contactData?.phone || "(905) 619-0811"}`}
                          className="d-flex align-items-center"
                        >
                          <p>{contactData?.phone || "(905) 619-0811"}</p>
                        </a>
                      </div>
                    </div>

                    <div className="col-12 col-lg-5 col-md-6 contact_field">
                      <div className="contact_icon">
                        <i className="bi bi-envelope-paper"></i>
                      </div>
                      <div className="d-flex flex-column align-items-start justify-content-start contact_info">
                        <h4>WRITE TO US</h4>
                        <a href={`mailto: ${contactData?.email}`} className="">
                          <p>{contactData?.email || "info@rollzicecream.ca"}</p>
                        </a>
                      </div>
                    </div>

                    <div className="col-12 contact_field">
                      <div className="contact_icon">
                        <i className="bi bi-geo-alt"></i>
                      </div>
                      <div className="d-flex flex-column align-items-start justify-content-start contact_info">
                        <h4>ADDRESS</h4>
                        <p>
                          {contactData?.address ||
                            "11 Harwood Ave S UNIT 104, Ajax, ON L1S 2B9"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 follow_us mb-4 mb-md-0">
                    <div className="col-md-10 follow_us_heading mb-3 pb-2">
                      <h3>Follow Us on</h3>
                    </div>
                    <div className="follow_us_icons">
                      <a
                        href="https://www.instagram.com/rollzicecreams/"
                        target="_blank"
                        title="Rollz Ice Creams - Instagram"
                      >
                        <img
                          src={insta}
                          alt=""
                          className="img-fluid"
                          loading="lazy"
                        />
                      </a>

                      <a
                        href="https://www.facebook.com/rollzicecream"
                        target="_blank"
                        title="Rollz Ice Creams - Facebook"
                      >
                        <img
                          src={fbImg}
                          alt=""
                          className="img-fluid"
                          loading="lazy"
                        />
                      </a>

                      <a
                        href="https://www.tiktok.com/@rollzicecream"
                        target="_blank"
                        title="Rollz Ice Creams - TikTok"
                      >
                        <img
                          src={tiktokImg}
                          alt=""
                          className="img-fluid"
                          loading="lazy"
                        />
                      </a>
                      <a
                        href="https://www.youtube.com/@rollzicecream"
                        target="_blank"
                        title="Rollz Ice Creams - Youtube"
                      >
                        <img
                          src={ytImg}
                          alt=""
                          className="img-fluid"
                          loading="lazy"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 d-flex flex-column contact_form_container gap-4">
                <h3>send your message</h3>
                <form
                  onSubmit={handleContact}
                  className="d-flex flex-column contact_form gap-3"
                >
                  {/* Name  */}
                  <div className="d-flex flex-column align-items-start justify-content-start">
                    <input
                      placeholder="Enter Your Name"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {error.name && (
                      <span className="error ms-0 px-2">
                        <i className="bi bi-exclamation-circle-fill me-1"></i>
                        {error.name}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column align-items-start justify-content-start">
                    <input
                      placeholder="Enter Phone Number"
                      className="form-control"
                      value={phone}
                      maxLength={10}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                    {error.phone && (
                      <span className="error ms-0 px-2">
                        <i className="bi bi-exclamation-circle-fill me-1"></i>
                        {error.phone}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column">
                    <input
                      placeholder="Enter Your Email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {error.email && (
                      <span className="error ms-0 px-2">
                        <i className="bi bi-exclamation-circle-fill me-1"></i>
                        {error.email}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column">
                    <input
                      placeholder="Subject"
                      className="form-control"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                    {error.subject && (
                      <span className="error ms-0 px-2">
                        <i className="bi bi-exclamation-circle-fill me-1"></i>
                        {error.subject}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column">
                    <textarea
                      cols={30}
                      rows={7}
                      placeholder="Message"
                      className="form-control"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                    {error.message && (
                      <span className="error ms-0 px-2">
                        <i className="bi bi-exclamation-circle-fill me-1"></i>
                        {error.message}
                      </span>
                    )}
                  </div>

                  {/* <div className="d-flex justify-content-center">
                  <OrderBtn text="Send Message" type="submit" url="/" />
                </div> */}
                  <div className="d-flex justify-content-center">
                    <div className="order-online">
                      <button className="blue-btn hero-anchor" type="submit">
                        <div className="order-online-trans-1"></div>
                        <div className="order-online-trans-2"></div>
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Map  */}
        <section className="d-flex justify-content-center contact_location">
          <Map locations={locations} width="100%" />
        </section>

        {/* <Footer color="#ffecf0" /> */}
      </div>
    </>
  );
};

export default ContactPage;
